const keyFor = item => `${item?.contentUid}:${item?.contentDocumentId}`

export const toAllowedContentSelection = (contents = []) => {
  const seen = new Set()

  return (contents || []).reduce((selection, item) => {
    const key = keyFor(item)
    if (!item?.contentUid || !item?.contentDocumentId || seen.has(key)) return selection
    seen.add(key)
    selection.push({
      contentUid: item.contentUid,
      contentDocumentId: item.contentDocumentId,
      accessState: 'available',
    })
    return selection
  }, [])
}

export const applyContentPreset = (form, group) => ({
  ...form,
  content_access_mode: 'allowlist',
  allowed_contents: toAllowedContentSelection(group?.contents),
})

// Presets are snapshots: the union is saved, never a live group dependency.
export const applyContentPresets = (form, groups = []) => ({
  ...form,
  content_selection_changed: true,
  content_group_ids: groups.map(group => String(group.documentId || group.id)),
  content_access_mode: 'allowlist',
  allowed_contents: toAllowedContentSelection(groups.flatMap(group => group.contents || [])),
})
